export class BundleAndSave extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            addToCart: "[js-add-to-cart]",
            select: "[js-bundle-select]",
            bundle: "[js-bundle]",
            error: "[js-error-message]",
            form: "[js-product-form]",
            loader: "loading-spinner",
        };
    }

    connectedCallback() {
        this.buttons = this.querySelectorAll(this._selectors.addToCart);
        this.select = this.querySelector(this._selectors.select);
        this.bundles = this.querySelectorAll(this._selectors.bundle);

        document.addEventListener("rebuy:smartcart.ready", (event) => {
            const smartCart = event.detail.smartcart;
            smartCart.destroy();
        });

        this._setListeners();
        this._initProductForm();
    }

    _setListeners() {
        if (this.select) {
            this.select.addEventListener("change", this._toggleBundle);
        }
    }

    _initProductForm() {
        this.forms = this.querySelectorAll(this._selectors.form);

        this.forms.forEach((form) => {
            form.addEventListener("submit", this.onSubmitHandler.bind(this));
        });

        this.cart = document.querySelector("cart-drawer");
        this.cartDrawer = document.querySelector("#CartDrawer");
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        this.handleErrorMessage();
        this._disableButtons();
        this._handleBundleAdd(evt);
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.querySelector(this._selectors.error);

        if (errorMessage) {
            this.errorMessageWrapper.innerHTML = errorMessage;
            this.errorMessageWrapper.classList.remove("hidden");
        } else {
            this.errorMessageWrapper.classList.add("hidden");
        }
    }

    _disableButtons() {
        this.buttons.forEach((button) => {
            button.setAttribute("disabled", "");
            const loader = button.querySelector(this._selectors.loader);
            if (loader) {
                loader.setAttribute("loading", "");
            }
        });
    }

    _enableButtons() {
        this.buttons.forEach((button) => {
            button.removeAttribute("disabled");
            const loader = button.querySelector(this._selectors.loader);
            if (loader) {
                loader.removeAttribute("loading");
            }
        });
    }

    _handleBundleAdd = (evt) => {
        // Init variables
        const form = evt.currentTarget;
        const data = {
            items: [],
            sections: this.cart
                .getSectionsToRender()
                .map((section) => section.id),
        };
        const date = new Date();

        // Get data
        const bundleElement = form.querySelector("[data-bundle-products]");
        const bundleProducts = JSON.parse(bundleElement.dataset.bundleProducts);
        const mainProductId = form.querySelector(
            `#${form.dataset.masterSelect}`,
        ).value;
        const mainProductObject = {
            id: parseInt(mainProductId, 10),
            quantity: 1,
        };

        data.items = bundleProducts;
        data.items.push(mainProductObject);

        // Setting properties
        data.items.forEach((item) => {
            item.properties = {};
            item.properties._bundleName = form.dataset.title;
            item.properties._bundleId = date;
        });

        mainProductObject.properties._bundleMainProduct = true;

        // Add products to cart
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this._enableButtons();
                location.href = "/cart";
            });
    };

    _toggleBundle = (evt) => {
        const value = evt.currentTarget.value;

        this.bundles.forEach((bundle) => {
            bundle.classList.add("hidden");
        });

        this.bundles.forEach((bundle) => {
            if (bundle.dataset.bundleId === value) {
                bundle.classList.remove("hidden");
            }
        });
    };
}
